// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom"; // Import navigation
// import * as signalR from "@microsoft/signalr";
// import { FaHome, FaArrowLeft } from "react-icons/fa";

// const GameSession = () => {
//     const { gameName, gameId } = useParams(); // Read from URL
//     const navigate = useNavigate(); // Hook for redirection
//     const [playerId] = useState(`Player-${Math.floor(Math.random() * 1000)}`);
//     const [messages, setMessages] = useState([]);
//     const [isAuthenticated, setIsAuthenticated] = useState(false);

//     const [connection] = useState(() =>
//         new signalR.HubConnectionBuilder()
//             .withUrl("http://localhost:5170/gamehub", {
//                 transport: signalR.HttpTransportType.WebSockets,
//                 withCredentials: true 
//             })
//             .withAutomaticReconnect()
//             .build()
//     );

//     useEffect(() => {
//         const token = localStorage.getItem("token");
//         if (!token) {
//             alert("⚠️ You must be logged in to join a game!");
//             navigate("/");
//         } else {
//             setIsAuthenticated(true);
//         }
//     }, [navigate]);

//     useEffect(() => {
//         if (connection.state === signalR.HubConnectionState.Disconnected) {
//             connection.start()
//                 .then(() => console.log("Connected to SignalR"))
//                 .catch(err => console.error("Connection error:", err));
//         }

//         connection.on("GameJoined", message => {
//             setMessages(prev => [...prev, message]);
//         });

//         connection.on("GameLeft", message => {
//             setMessages(prev => [...prev, message]);
//         });

//         connection.on("GameStarted", message => {
//             alert(message);
//         });

//         return () => {
//             connection.stop().then(() => console.log("🔴 Disconnected from SignalR"));
//         };
//     }, [connection]);

    

//     return (
//         <div className="popup">
//             <div className="popup-content">
//                 {/* Home Icon */}              
                
//                 <h3>🕹️ {gameName}</h3>
//                 {/* <p>Game ID: {gameId}</p>
//                 <button onClick={joinGame}>Join Game</button>
//                  */}
//                 {/* <div>
//                     {messages.map((msg, index) => (
//                         <p key={index}>{msg}</p>
//                     ))}
//                 </div> */}
//             </div>
//         </div>
//     );
// };

// export default GameSession;


// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import * as signalR from "@microsoft/signalr";
// import { FaHome } from "react-icons/fa";

// const GameSession = () => {
//     const { gameName, gameId } = useParams();
//     const navigate = useNavigate();
//     const [playerId] = useState(`Player-${Math.floor(Math.random() * 10000)}`);
//     const [messages, setMessages] = useState([]);
//     const [connection, setConnection] = useState(null);
//     const [isJoined, setIsJoined] = useState(false);

//     useEffect(() => {
//         const token = localStorage.getItem("token");
//         if (!token) {
//             alert("⚠️ You must be logged in to join a game!");
//             navigate("/");
//         }
//     }, [navigate]);

//     useEffect(() => {
//         const newConnection = new signalR.HubConnectionBuilder()
//             .withUrl("http://localhost:5170/gamehub", {
//                 transport: signalR.HttpTransportType.WebSockets,
//                 withCredentials: true
//             })
//             .withAutomaticReconnect()
//             .build();

//         setConnection(newConnection);
//     }, []);

//     useEffect(() => {
//         if (connection) {
//             connection
//                 .start()
//                 .then(() => {
//                     console.log("✅ Connected to game hub");
                    
//                     connection.on("GameJoined", (msg) => {
//                         setMessages(prev => [...prev, msg]);
//                     });

//                     connection.on("GameLeft", (msg) => {
//                         setMessages(prev => [...prev, msg]);
//                     });

//                     connection.on("GameStarted", (msg) => {
//                         setMessages(prev => [...prev, `🎮 ${msg}`]);
//                         alert("🎯 Game Started!");
//                     });
//                 })
//                 .catch((err) => console.error("SignalR error:", err));

//             return () => {
//                 connection.stop().then(() => console.log("🔌 Disconnected from SignalR"));
//             };
//         }
//     }, [connection]);

//     const joinGame = async () => {
//         if (connection && connection.state === signalR.HubConnectionState.Connected) {
//             try {
//                 await connection.invoke("JoinGame", {
//                     gameId,
//                     gameName,
//                     playerId,
//                 });
//                 setIsJoined(true);
//             } catch (error) {
//                 console.error("Error joining game:", error);
//                 alert("⚠️ Failed to join the game. Please try again.");
//             }
//         }
//     };

//     const leaveGame = async () => {
//         if (connection && connection.state === signalR.HubConnectionState.Connected) {
//             await connection.invoke("LeaveGame", {
//                 gameId,
//                 playerId,
//             });
//             setIsJoined(false);
//         }
//     };

//     return (
//         <div className="popup">
//             <div className="popup-content text-center">
//                 <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1rem" }}>
//                     <button className="btn btn-sm btn-outline-primary" onClick={() => navigate("/")}>
//                         <FaHome /> Home
//                     </button>
//                     {isJoined && (
//                         <button className="btn btn-sm btn-outline-danger" onClick={leaveGame}>
//                             Leave
//                         </button>
//                     )}
//                 </div>
                
//                 <h2>🕹️ {gameName}</h2>
//                 <p>Game ID: {gameId}</p>
//                 <p>Your ID: {playerId}</p>

//                 {!isJoined && (
//                     <button className="btn btn-success" onClick={joinGame}>
//                         Join Game
//                     </button>
//                 )}

//                 <div className="mt-4 text-start">
//                     <h5>🎤 Lobby Chat:</h5>
//                     <div style={{ maxHeight: 200, overflowY: "auto" }}>
//                         {messages.map((msg, i) => (
//                             <p key={i} style={{ fontSize: 14 }}>{msg}</p>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default GameSession;

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import * as signalR from "@microsoft/signalr";
import { FaHome } from "react-icons/fa";
import AdComponent from "./AdComponent";

const GameSession = () => {
    const { gameName, gameId } = useParams();
    const navigate = useNavigate();
    const [playerId] = useState(`Player-${Math.floor(Math.random() * 10000)}`);
    const [messages, setMessages] = useState([]);
    const [connection, setConnection] = useState(null);
    const [isJoined, setIsJoined] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            alert("⚠️ You must be logged in to join a game!");
            navigate("/");
        } else {
            const newConnection = new signalR.HubConnectionBuilder()
                .withUrl(`http://localhost:5170/gamehub?access_token=${token}`, {
                    transport: signalR.HttpTransportType.WebSockets
                })
                .withAutomaticReconnect()
                .build();

            setConnection(newConnection);
        }
    }, [navigate]);

    useEffect(() => {
        if (connection) {
            connection
                .start()
                .then(() => {
                    console.log("✅ Connected to game hub");

                    connection.on("GameJoined", (msg) => {
                        const text = `${msg.playerId} joined ${msg.gameName}`;
                        setMessages(prev => [...prev, text]);
                    });

                    connection.on("GameLeft", (msg) => {
                        const text = `${msg.playerId} left ${msg.gameName}`;
                        setMessages(prev => [...prev, text]);
                    });

                    connection.on("GameStarted", (msg) => {
                        setMessages(prev => [...prev, `🎮 ${msg}`]);
                        alert("🎯 Game Started!");
                    });
                })
                .catch((err) => console.error("SignalR error:", err));

            return () => {
                connection.stop().then(() => console.log("🔌 Disconnected from SignalR"));
            };
        }
    }, [connection]);

    // const joinGame = async () => {
    //     if (connection && connection.state === signalR.HubConnectionState.Connected) {
    //         try {
    //             await connection.invoke("JoinGame", {
    //                 gameId,
    //                 gameName,
    //                 playerId,
    //             });
    //             setIsJoined(true);
    //         } catch (error) {
    //             console.error("Error joining game:", error);
    //             alert("⚠️ Failed to join the game. Please try again.");
    //         }
    //     }
    // };

    const joinGame = async () => {
        try {
            // 1. First join the SignalR group
            await connection.invoke("JoinGame", {
                gameId,
                gameName,
                playerId,
            });
    
            // 2. Then get the game URL
            const gameUrl = await connection.invoke("GetGameUrl", gameId);
            console.log("Game URL:", gameUrl);
            
            // 3. Open game in new tab
            window.open(gameUrl, "_blank");
            
        } catch (error) {
            console.error("Join game failed:", {
                error: error.message,
                details: error.response || error.stack
            });
            alert("Failed to launch game. Check console for details.");
        }
    };

    const leaveGame = async () => {
        if (connection && connection.state === signalR.HubConnectionState.Connected) {
            await connection.invoke("LeaveGame", {
                gameId,
                playerId,
            });
            setIsJoined(false);
        }
    };

    return (
       
        
        <div className="popup">
            <div className="popup-content shadow rounded p-4 bg-white position-relative" style={{ maxWidth: 500, margin: "auto", top: 150 }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="mb-0">{gameName}</h4>
                {isJoined && (
                    <button className="btn btn-sm btn-outline-danger" onClick={leaveGame}>
                    Leave
                    </button>
                )}
                </div>

                {/* <div className="text-muted mb-3">
                <div><strong>Game ID:</strong> {gameId}</div>
                <div><strong>Your ID:</strong> {playerId}</div>
                </div> */}

                {/* {!isJoined && (
                <div className="text-center mb-4">
                    <button className="btn btn-success btn-lg w-100" onClick={joinGame}>
                    Join Game
                    </button>
                </div>
                )} */}

                {/* <div className="chat-section mb-4">
                <h5 className="mb-2">🎤 Lobby Chat</h5>
                <div className="border rounded p-2" style={{ maxHeight: 200, overflowY: "auto", background: "#f9f9f9" }}>
                    {messages.length ? messages.map((msg, i) => (
                    <p key={i} style={{ fontSize: 14, margin: "0.3rem 0" }}>{msg}</p>
                    )) : <p className="text-muted">No messages yet.</p>}
                </div>
                </div> */}

                <div className="ad-section border-top pt-3 mt-3">
                <h6 className="text-muted">Sponsored</h6>
                <AdComponent adSlot="XXXXXXXXXX" /> {/* Replace with your actual ad slot ID */}
                </div>
            </div>
            </div>
            );
        };

export default GameSession;
